import type { DynamicPropertyGroupDto } from "../../types/DynamicPropertyGroupDto";
import type { DynamicPropertyGroupEntity } from "../../types/DynamicPropertyGroupEntity";

export const DynamicPropertyGroupDtoToEntity = ({
    dynamicPropertyToGroups,
    ...rest
}: Readonly<DynamicPropertyGroupDto>): DynamicPropertyGroupEntity => {
    const propertyToGroup = dynamicPropertyToGroups?.map((prop) => {
        return { ...prop, keyProp: prop.key };
    });
    return { ...rest, dynamicPropertyToGroups: propertyToGroup };
};
